import { action } from "typesafe-actions";

import { SET_USER, SET_USER_ACCESS } from "./types";

export const setUser = (payload: string | number) => action(SET_USER, payload);

export const setUserAccess = (payload: { role: string; isAdmin: boolean; canManageRoles: boolean }) =>
  action(SET_USER_ACCESS, payload);
